import { render } from "./InvoiceSourceDocumentsPanel.vue?vue&type=template&id=32becee1&scoped=true"
import script from "./InvoiceSourceDocumentsPanel.vue?vue&type=script&lang=js"
export * from "./InvoiceSourceDocumentsPanel.vue?vue&type=script&lang=js"

import "./InvoiceSourceDocumentsPanel.vue?vue&type=style&index=0&id=32becee1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32becee1"]])

export default __exports__